module.exports = __webpack_public_path__ + "img/PolynomialRegression1.d20c2ddd.png";